import styled from '~/utils/styled';
// ---- external imports ----

import Asset from '~/containers/GameAsset/BaseAssets';
import { TextCursor, DeniedCursor } from '~/containers/GameAsset/cursors';
import {
	FieldInput as BaseFieldInput,
	PrimaryButton,
	createPrimaryButtonText
} from '~/authentication/AuthAssets';
// ---- internal imports ----

// region [Projection Constants]
export const TITLE_PROJECTION = { width: 451 };
export const BODY_TEXT_PROJECTION = { width: 632 };
export const EMAIL_LABEL_PROJECTION = { width: 632 };
export const INPUT_BG_PROJECTION = { width: 632, height: 76 };
export const EMAIL_INPUT_PROJECTION = { width: 632, height: 76 };
export const REQUEST_LINK_BTN_TEXT_PROJECTION = { width: 158 };
// endregion

// region [Components]

export const BodyText = styled(Asset.Text.withProps({
	fontSize: 32,
}))`

	font-family: "NotoSans ExtraBold";
	color: #fff5b0;
	text-align: left;
`;

export const ErrorText = styled(Asset.Text)`
	font-family: "NotoSans";
	color: #fff5b0;
	text-align: left;
`;

export const EmailLabel = styled(Asset.Text)`
	font-family: "NotoSans";
	color: #fff5b0;
`;

export const EmailInput = styled(Asset.Input.withProps({
	fontSize: 32,
	projection: EMAIL_INPUT_PROJECTION,
}))`
	font-family: "NotoSans ExtraBold";
	color: #fff5b0;
	border-radius: 12px;
	padding: 0 16px;
	box-sizing: border-box;
	${TextCursor};

	::placeholder {
		color: rgba(114, 37, 12, 1);
		font-family: 'NotoSans SemiBold'
	};

	&:disabled {
		${DeniedCursor};
	};

	${({ hasError }) => hasError && `
		border: 4px solid #D63B25;
		box-shadow: inset 0 0 17px 0 rgba(0, 0, 0, 0.25);
	`}
`;

export const RequestButton = PrimaryButton;

export const RequestButtonText = createPrimaryButtonText(REQUEST_LINK_BTN_TEXT_PROJECTION);

export const BackToLoginLink = styled(Asset.Link)`
	font-family: "NotoSans";
	color: #fff5b0;
	text-decoration: underline;
`;

// endregion
